import { styled, styledForMobile, YearSelector as UiYearSelector } from "@l2r-front/l2r-ui"

export const Container = styledForMobile("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
}))

export const YearSelector = styled(UiYearSelector)({
    margin: 0,
}) 